import { GameStateContext } from "@/context/GameStateContext";
import type { GameStateContextType } from "@/context/GameStateContext";
import { useContext } from "react";

export function useGameState(): GameStateContextType {
  const context = useContext(GameStateContext);
  if (context === null) {
    throw new Error('useGameState must be used within a GameStateProvider');
  }
  return context;
}